import React from 'react';
import { CampaignDraft } from 'src/components-bl/EmailMarketing/types/campaign-draft';
import { WidgetMaker } from 'src/components-bl/EmailMarketing/types/widget-maker';
import { useCatalogFields } from '../useCatalogFields';
import { DraggableCard } from './DraggableCard';
import { EmptyCard } from './EmptyCard';
import { ParseJoiValidateResponse } from 'src/utils';

interface ProductCardSectionProps {
  widgetMaker: Partial<WidgetMaker>;
  onChange: (campaign: CampaignDraft) => void;
  errors: ParseJoiValidateResponse<WidgetMaker>;
}

export const ProductCardSection = ({
  widgetMaker,
  onChange,
  errors,
}: ProductCardSectionProps): JSX.Element => {
  const {
    dataFieldsToDisplay,
    onMoveCard,
    dataFieldsDropdownOptions,
    handleSelectChange,
    handleStyleChange,
    onRemove,
    onAdd,
    isEmpty,
  } = useCatalogFields({
    onChange,
    widgetMaker,
  });

  return (
    <div>
      {isEmpty ? (
        <EmptyCard onAdd={onAdd} />
      ) : (
        dataFieldsToDisplay.map((card, index) => {
          const isLastCard = index === dataFieldsToDisplay.length - 1;
          const isFirstCard = index === 0;
          return (
            <DraggableCard
              key={card.id}
              field={card}
              index={index}
              dataFieldsDropdownOptions={dataFieldsDropdownOptions}
              handleSelectChange={handleSelectChange}
              onRemove={onRemove}
              onAdd={onAdd}
              isLastCard={isLastCard}
              isFirstCard={isFirstCard}
              onMoveCard={onMoveCard}
              productCardConfig={widgetMaker?.productCard?.[index]}
              handleStyleChange={handleStyleChange}
              errors={errors}
            />
          );
        })
      )}
    </div>
  );
};
